(function () {
  function initTierCardPress(root) {
    if (root.dataset.tierPressInitialized === 'true') return;

    var cards = root.querySelectorAll('.membership__tiers .tier-card');
    if (!cards.length) return;

    function pressCard(card) {
      var group = card.closest('.membership__tiers');
      if (!group) return;

      group.querySelectorAll('.tier-card.is-pressed').forEach(function (other) {
        if (other !== card) other.classList.remove('is-pressed');
      });
      card.classList.add('is-pressed');
    }

    cards.forEach(function (card) {
      card.addEventListener(
        'pointerdown',
        function (event) {
          if (event.pointerType === 'mouse') return;
          pressCard(card);
        },
        { passive: true }
      );

      card.addEventListener(
        'touchstart',
        function () {
          pressCard(card);
        },
        { passive: true }
      );
    });

    root.dataset.tierPressInitialized = 'true';
  }

  function initMembership(root) {
    if (root.dataset.membershipInitialized === 'true') return;

    var tabs = root.querySelectorAll('[data-membership-tab]');
    var panels = root.querySelectorAll('[data-membership-panel]');
    var titles = root.querySelectorAll('[data-membership-title]');
    var tabsEl = root.querySelector('.membership__tabs');
    var indicator = root.querySelector('[data-membership-indicator]');
    if (!tabs.length || !panels.length) return;

    function moveIndicator() {
      if (!indicator || !tabsEl) return;

      var active = root.querySelector('[data-membership-tab].is-active');
      if (!active) return;

      var tabsRect = tabsEl.getBoundingClientRect();
      var tabRect = active.getBoundingClientRect();

      indicator.style.width = tabRect.width + 'px';
      indicator.style.height = tabRect.height + 'px';
      indicator.style.transform =
        'translateX(' + (tabRect.left - tabsRect.left) + 'px)';
    }

    function activate(tabId) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-membership-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-membership-panel') === tabId;
        panel.hidden = !isActive;
      });

      titles.forEach(function (title) {
        var isActive = title.getAttribute('data-membership-title') === tabId;
        title.hidden = !isActive;
      });

      moveIndicator();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-membership-tab'));
      });

      tab.addEventListener('keydown', function (event) {
        var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(event.key) === -1) return;

        event.preventDefault();
        var tabList = Array.prototype.slice.call(tabs);
        var currentIndex = tabList.indexOf(tab);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabList.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabList.length) % tabList.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabList.length - 1;

        tabList[nextIndex].focus();
        activate(tabList[nextIndex].getAttribute('data-membership-tab'));
      });
    });

    moveIndicator();
    requestAnimationFrame(function () {
      tabsEl.classList.add('is-ready');
    });

    window.addEventListener('resize', moveIndicator);

    root.dataset.membershipInitialized = 'true';
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-membership]').forEach(function (root) {
      initMembership(root);
      initTierCardPress(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }
})();
